import React from 'react';
import { navigate } from 'gatsby';
import { useTranslation } from 'react-i18next';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Link } from '@mui/material';
import { ParagraphComponent } from 'common-app/paragraph';
import CloseIcon from 'core/assets/icons/close.svg';
import { namespaces } from 'core/i18n';
import { routes } from 'core/router';
import { keys } from '../translations';
import * as classes from './cookies-config.styles';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onAccept: () => void;
}

export const CookiesConfig: React.FC<Props> = props => {
  const { t } = useTranslation(namespaces.commonApp.cookesPopup);
  const { isOpen, onClose, onAccept } = props;
  return (
    <Dialog open={isOpen} fullWidth maxWidth="sm" className={classes.root}>
      <DialogTitle>
        <ParagraphComponent label={t(keys.dialog.title)} />
        <IconButton onClick={onClose} className={classes.closeIcon}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <div className={classes.content}>
          <ParagraphComponent label={t(keys.dialog.description)} />
          <ParagraphComponent
            label={t(keys.linkLabel)}
            componentInterpolation={[
              <Link
                key={0}
                onClick={() => {
                  navigate(routes.cookies);
                  onClose();
                }}
              />,
            ]}
          />
        </div>
      </DialogContent>
      <DialogActions className={classes.buttonContainer}>
        <Button variant="outlined" onClick={onAccept}>
          {t(keys.rejectAll)}
        </Button>
        <Button variant="outlined" onClick={onAccept} color="secondary">
          {t(keys.acceptAll)}
        </Button>
        <Button variant="contained" onClick={onAccept} color="secondary">
          {t(keys.saveSettings)}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
